(() => {
  'use strict';
  let trigger;
  document.querySelectorAll('[data-dialog]').forEach(button => button.addEventListener('click', () => {
    const dialog = document.getElementById(button.dataset.dialog);
    if (!dialog) return;
    trigger = button; dialog.showModal(); document.body.style.overflow = 'hidden';
    const video = dialog.querySelector('video');
    if (video) {
      video.currentTime = 0;
      video.play().catch(() => { dialog.querySelector('[role="status"]').textContent = 'Press play to watch the film.'; });
    }
  }));
  document.querySelectorAll('.sa-dialog').forEach(dialog => {
    dialog.querySelector('[data-close]').addEventListener('click', () => dialog.close());
    dialog.addEventListener('click', e => {
      const r = dialog.getBoundingClientRect();
      if (e.target === dialog && (e.clientX < r.left || e.clientX > r.right || e.clientY < r.top || e.clientY > r.bottom)) dialog.close();
    });
    dialog.addEventListener('close', () => {
      dialog.querySelector('video')?.pause();
      document.body.style.overflow = ''; trigger?.focus();
    });
    const video = dialog.querySelector('video');
    if (video) {
      video.addEventListener('playing', () => { dialog.querySelector('[role="status"]').textContent = ''; });
      video.addEventListener('error', () => { dialog.querySelector('[role="status"]').textContent = 'The film couldn’t load. You can read the story below.'; });
    }
  });
})();
